import React from 'react';
import { connect } from 'react-redux';
import { processType } from 'constants/process-type';
import { validatable } from 'components/utils';
import { msg } from 'constants/message';

const process = [processType.xuLyDon.processing.lanhDaoThuHoi, processType.xuLyDon.processing.truongPhongThuHoi];

class ThuHoiPU extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_ThuHoi: false,

      donId: this.props.donId,

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      content: this.props.content
    }
  }

  componentWillMount() {
    this.checkState();
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';

    process.map((item, i) => {
      if (this.props.getState(this.props.listNextStates, item)) {
        onlyState = item;
        numberState++;
        switch (item) {
          case processType.xuLyDon.processing.truongPhongThuHoi:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_ThuHoi: true
            })
          break;
          case processType.xuLyDon.processing.lanhDaoThuHoi:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_ThuHoi: true
            })
          break;
          default: break;
        }
      }
    });
  }

  componentDidMount() {

    this.onlyOneState();

  }

  onlyOneState() {

    if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState, true));
    }
  }

  handleChange(name, e) {



    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    this.setState({
      ...newState
    }, this.trigger(newState, false));
  }

  trigger(newState, isInit) {

    if (newState.nextState) {

      let stateId = this.props.getState(this.props.listNextStates, newState.nextState);

      let params = {
        nextState: {
          id: Number(stateId)
        }
      }

      if (newState.form_ThuHoi) {
        params.notice = msg.thuHoiDon;
      }

      this.props.onChange(params, isInit);
    }
  }
  render() {
    return (
      <div className="pt-dialog-body">
        <p className="reception-dialog-text">{this.state.content}</p>
      </div>
    );
  }
}

ThuHoiPU.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  }
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
  }
}

export default connect(bindStateToProps)(validatable(ThuHoiPU));



// WEBPACK FOOTER //
// ./src/components/modules/dialog/thu-hoi-form/ThuHoiPU.jsx